import { initializePaddle, type Paddle } from '@paddle/paddle-js';
import envConfig from '../config/environment';

let _promise: Promise<Paddle | undefined> | null = null;

export function getPaddle(): Promise<Paddle | undefined> {
  if (!envConfig.paddleClientToken) return Promise.resolve(undefined);
  if (!_promise) {
    _promise = initializePaddle({
      environment: envConfig.paddleEnvironment,
      token: envConfig.paddleClientToken,
    }).catch(() => undefined);
  }
  return _promise;
}
